import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar/Navbar";
import { ScoreComponent } from "../components/ScoreComponent/ScoreComponent";
import { ScoreStringComponent } from "../components/ScoreComponent/ScoreStringComponent";
import { useSelector } from "react-redux";
import { LeakData } from "../components/ReportComponent/LeakData";
import { TypeComp } from "../components/TypeSite/TypeComp";
import { PresentationComp } from "../components/ReportComponent/PresentationComp";
import { StatusProject } from "../components/ReportComponent/StatusProject";
import { ResultPieChart } from "../components/ReportComponent/ResultPieChart";
import { notify } from "../services/toast-function";
import { ToastContainer } from "react-toastify";

export const ReportPage = () => {
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const formDataDic = useSelector((state) => state.formDataDic);
  const [dataFetched, setDataFetched] = useState({
    faisabilite: -1,
    adequation_budget: -1,
    clarte_reponses: 2,
    risque_financier: -1,
    capacite_maintenance: -1,
    estimation_cout: "-1",
    estimation_cout_explanation: "",
    besoin_assistance: -1,
    simplification_ambitions: -1,
    note_generale: -1,
    resume_user: "",
    resume: "",
  });
  const tabKeyNumber = [
    "faisabilite",
    "adequation_budget",
    "clarte_reponses",
    "risque_financier",
    "capacite_maintenance",
    "besoin_assistance",
    "simplification_ambitions",
    "note_generale",
  ];
  const tabKeyString = [
    "resume_user",
    "resume",
    "estimation_cout",
    "estimation_cout_explanation",
  ];

  const tabDescription = {
    faisabilite:
      "Évaluation de la possibilité technique et pratique de réaliser le projet selon les besoins présentés.",
    adequation_budget:
      "Analyse de la correspondance entre le budget du client et les exigences du projet.",
    clarte_reponses:
      "Évaluation de la clarté et de la cohérence des informations fournies par le client.",
    risque_financier:
      "Évaluation du danger potentiel pour le client de dépasser son budget et de se mettre en difficulté financière.",
    capacite_maintenance:
      "Estimation de la capacité du client à gérer et à maintenir le projet avec ses propres ressources.",
    estimation_cout:
      "Réponse en euros (€). Une estimation approximative du coût total du projet en fonction des besoins énoncés par le client.",
    estimation_cout_explanation:
      "Explication succinte d'un ordre de grandeur de coût qui pourrait être estimé",
    besoin_assistance:
      "Évaluation de la nécessité pour le client d'obtenir une aide professionnelle pour formaliser les spécifications du projet.",
    simplification_ambitions:
      "Evaluation de la nécessité de simplifier les ambitions du projet pour rester dans le budget du client",
    note_generale:
      "Evaluation générale de la faisabilité du projet à l'instant t",
    resume_user:
      "Nous avons réécrit les informations que vous avez fournies en réponse aux questions posées.",
    resume:
      "Dans ces quelques phrases, vous trouverez les points positifs et négatifs liés à la réalisation du projet. Si vos notes sont inférieures à 7, nous vous conseillons de prendre rendez-vous avec nous, car vous pourriez rencontrer des difficultés dans la réalisation de votre projet.",
  };

  const tabTitle = {
    faisabilite: "Faisabilité",
    adequation_budget: "Adéquation du budget avec les besoins présentés",
    clarte_reponses: "Clarté des réponses du client ",
    risque_financier: "Risque financier pour le client",
    capacite_maintenance: "Capacité de maintien du projet en interne",
    estimation_cout: "Estimation du coût du projet",
    estimation_cout_explanation: "Explication de l'estimation",
    besoin_assistance:
      "Autonomie pour la rédaction d'un cahier des charges ou un MVP",
    simplification_ambitions: "Besoin de simplification des exigences",
    note_generale: "Note générale",
    resume_user: "Résumé des besoins clients récupérés",
    resume: "Résumé global de l'analyse client",
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL_API}/api/analyse/report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password: formDataDic?.uid,
        email: formDataDic?.email,
      }),
    })
      .then((data) => {
        if (data.ok) {
          console.log("boudoum")
          return data.json();
        }
        throw new Error("a problem occurs on returning user");
      })
      .then((data) => {
        setDataFetched(data);
        setIsDataAvailable(true);
      })
      .catch((error) => {
        console.log("error near /report: ",error);
        return notify("Oops!Une erreur c'est produite, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");
      });
  }, [formDataDic]);

  return (
    <>
    
      <Navbar />
      <ToastContainer/>
      {isDataAvailable ? (
        <div id="pdf-content">
          <StatusProject status={dataFetched["status"]} />
          <PresentationComp />
          <div className=" flex flex-col m-2 gap-2 justify-center">
            {tabKeyString?.map((e) => {
              return (
                <ScoreStringComponent
                  key={e}
                  title={tabTitle[e]}
                  description={tabDescription[e]}
                  analyze={dataFetched[e]}
                />
              );
            })}
          </div>
          <ResultPieChart dataPie={dataFetched["estimation_cout_pie_chart"]?dataFetched["estimation_cout_pie_chart"][0]:null}/>
          <div className=" flex flex-wrap m-2 gap-2 justify-center">
            {tabKeyNumber.map((e) => {
              return (
                <ScoreComponent
                  key={e}
                  title={tabTitle[e]}
                  description={tabDescription[e]}
                  score={dataFetched[e]}
                  keyDic={e}
                />
              );
            })}
          </div>
        </div>
      ) : (
        <LeakData />
      )}
      <div className="flex flex-row justify-center items-center m-4">
        <TypeComp
          title={"Site traditionnel"}
          description={"ex: Landing page"}
          tabList={["Informatif", "statique", "contenu simple"]}
        />
        <input
          id="large-range"
          type="range"
          value={dataFetched["type_projet"] ? dataFetched["type_projet"] : 50}
          onChange={() => {}}
          className="w-1/5 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer range-lg dark:bg-gray-700"
        ></input>
        <TypeComp
          title={"App web"}
          description={"ex: Youtube"}
          tabList={["Interactif", "dynamique", "interactions complexes"]}
        />
      </div>
    </>
  );
};
